export default __webpack_public_path__ + "static/media/trr-drink-juicecocktail-orangehorizon.49be96a5.png";